import { jsx as _jsx } from "react/jsx-runtime";
import { Cancel, CheckCircle, Error, Info, } from '@mui/icons-material';
let id = 0;
const toastPropertiesByType = (type, color, icon) => {
    const properties = {
        default: {
            icon: _jsx(Info, {}),
            color: '#4F67F3',
        },
        success: {
            icon: _jsx(CheckCircle, {}),
            color: '#00D287',
        },
        warning: {
            icon: _jsx(Error, {}),
            color: '#FBC506',
        },
        error: {
            icon: _jsx(Cancel, {}),
            color: '#F24C27',
        },
        custom: {
            icon,
            color,
        },
    };
    return properties[type];
};
const toastFactory = ({ type = 'default', title, description, color, icon, autoDeleteTime = true, }) => {
    id += 1;
    return Object.assign(Object.assign({}, toastPropertiesByType(type, color || '', icon)), { autoDeleteTime,
        id,
        title,
        description });
};
export default toastFactory;
